module.exports = __webpack_public_path__ + "static/media/sport_cheer_banner_right.72fdb4e6.png";